// 一般用的axios
import req from './http.js'
// 專門給下載檔案用的axios
import f_req from './f_http.js'

// 取得票券回兌狀態excel檔案api
export const apiListToExcel = params => req('post', '/reservation/report/makeJsonToExcel', params)

// 下載檔案用api
export const apiDownloadFile = path => f_req('get', path)

// call directus api
export const apiGetDirectusData = params => req('post', '/proxy/directus', params)